import { render, staticRenderFns } from "./StandardDialog.component.vue?vue&type=template&id=dd1cd38a&"
import script from "./StandardDialog.component.vue?vue&type=script&lang=js&"
export * from "./StandardDialog.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardDialog.component.vue?vue&type=style&index=0&id=dd1cd38a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports